import { useEffect } from 'react';
import { Box, Button, Container, Divider, Stack, Typography } from '@mui/material';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import RefreshIcon from '@mui/icons-material/Refresh';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import { makeStyles } from 'tss-react/mui';
import { getLogger } from '@logging/logger';

const useStyles = makeStyles()((theme) => ({
  container: {
    padding: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    gap: 2,
  },
  errorIconContainer: {
    borderRadius: '50%',
    width: 96,
    height: 96,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgb(254, 252, 232)',
  },
}));

export function MaintenanceError({ title, message, subMessage }: { title?: string; message?: string; subMessage?: string }) {
  const { classes } = useStyles();
  useEffect(() => {
    getLogger().info('MaintenanceError page rendered', { route: window.location.pathname });
  }, []);
  return (
    <Container maxWidth='xl' className={classes.container}>
      <Stack
        spacing={4}
        direction={'column'}
        sx={{
          alignItems: 'center',
          marginBottom: 16,
        }}
      >
        <div className={classes.errorIconContainer}>
          <BuildOutlinedIcon sx={{ fontSize: 44, color: '#ca8a04' }} />
        </div>
        <Typography variant='h1'>{title || 'Under Maintenance'}</Typography>
        <Typography variant='body1'>
          {message || "We're performing scheduled maintenance to improve your experience. We'll be back up shortly."}
        </Typography>
        <Typography variant='body1'>{subMessage || 'Your items and designs are safe — please check back in a few minutes.'}</Typography>
        <Box>
          <Stack direction={'row'} spacing={2}>
            <Button variant='contained' color='primary' onClick={() => window.location.reload()}>
              <RefreshIcon />
              &nbsp; Try Again
            </Button>
          </Stack>
        </Box>
        <Divider flexItem />
        <Typography variant='subtitle1'>Need urgent assistance?</Typography>
        <Button variant='contained' color='secondary' onClick={() => window.location.assign('https://www.squadlocker.com/email-us')}>
          <ContactSupportIcon />
          &nbsp; Contact Support
        </Button>
      </Stack>
    </Container>
  );
}
